import { DispatchType, StoreAction, StoreState } from "../reduxTypes";
import { Error202, parseError } from "../../utils/http-helper";
import { getSession } from "../../utils/session-helper";
import procedimentosService from "../../services/procedimentoCooperado";
import { formatDataBr, moneyToNumber } from "../../utils/functions-helper";
import { message } from "antd";

export const INICIALIZA_ESTADO = "PROCEDIMENTO_COOPERADO__INICIALIZA_ESTADO";
export const SET_DADOS_PROCEDIMENTOS =
  "PROCEDIMENTO_COOPERADO__SET_DADOS_PROCEDIMENTOS";
export const SET_LISTA_PROCEDIMENTOS =
  "PROCEDIMENTO_COOPERADO__SET_LISTA_PROCEDIMENTOS";
export const SET_CONTRATOS = "PROCEDIMENTO_COOPERADO__SET_CONTRATOS";
export const SET_FILTROS = "PROCEDIMENTO_COOPERADO__SET_FILTROS";
export const SET_FORM = "PROCEDIMENTO_COOPERADO__SET_FORM";
export const LIMPAR_FILTROS = "PROCEDIMENTO_COOPERADO__LIMPAR_FILTROS";
export const LIMPAR_FORM = "PROCEDIMENTO_COOPERADO__LIMPAR_FORM";
export const SET_LOADING = "PROCEDIMENTO_COOPERADO__SET_LOADING";

function setFiltros(dados: Record<string, any>): StoreAction {
  return {
    type: SET_FILTROS,
    payload: dados,
  };
}

function setForm(dados: Record<string, any>): StoreAction {
  return {
    type: SET_FORM,
    payload: dados,
  };
}

function setDadosProcedimentos(dados: Object): StoreAction {
  return {
    type: SET_DADOS_PROCEDIMENTOS,
    payload: dados,
  };
}

function setContratos(dados: Object): StoreAction {
  return {
    type: SET_CONTRATOS,
    payload: dados,
  };
}

function setListaProcedimentos(dados: Object): StoreAction {
  return {
    type: SET_LISTA_PROCEDIMENTOS,
    payload: dados,
  };
}

function setRequisitado(): StoreAction {
  return { type: INICIALIZA_ESTADO };
}

function limparFiltros(): StoreAction {
  return { type: LIMPAR_FILTROS };
}

function limparForm(completo: boolean = false): StoreAction {
  return { type: LIMPAR_FORM, payload: completo };
}

function setLoading(loading: boolean): StoreAction {
  return {
    type: SET_LOADING,
    payload: loading,
  };
}

function buscarDadosIniciais() {
  return async function (dispatch: DispatchType) {
    const { userData } = await getSession();
    if (!userData) return;

    dispatch(setLoading(true));

    return procedimentosService
      .buscarDadosIniciais(userData.CooperadoID)
      .then((resp) => {
        const { data } = resp;

        if (typeof data === typeof { ListaContrato: [] }) {
          dispatch(setContratos(data.ListaContrato));
        } else {
          dispatch(setContratos([]));
        }
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      })
      .finally(() => dispatch(setLoading(false)));
  };
}

function buscarListaProcedimentos(contratoID: string) {
  return function (dispatch: DispatchType) {
    dispatch(setLoading(true));
    if (contratoID.length === 0 || contratoID === "0") {
      dispatch(setListaProcedimentos([]));
      dispatch(setLoading(false));
      return;
    }

    return procedimentosService
      .buscarProcedimentos(contratoID)
      .then((resp) => {
        const { data } = resp;

        if (typeof data === typeof []) {
          dispatch(setListaProcedimentos(data));
        } else {
          dispatch(setContratos([]));
        }
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      })
      .finally(() => dispatch(setLoading(false)));
  };
}

function buscarProcedimentosCooperado(contrato: string, competencia: string) {
  if (competencia.length !== 7) return;

  return async function (dispatch: DispatchType) {
    const { userData } = await getSession();
    if (!userData) return;

    const competenciaFiltro = Number(competencia.split("/").reverse().join(""));
    dispatch(setLoading(true));
    return procedimentosService
      .buscarProcedimentosCooperado(
        contrato,
        competenciaFiltro,
        userData.CooperadoID
      )
      .then((resp) => {
        const { data } = resp;

        dispatch(setDadosProcedimentos(typeof data === typeof [] ? data : []));
      })
      .finally(() => dispatch(setLoading(false)));
  };
}

function criarProcedimentosCooperado(
  ID_Contrato: string,
  competenciaFiltro: string,
  form: Record<string, any>
) {
  if (competenciaFiltro.length !== 7) return;

  return async function (dispatch: DispatchType) {
    const { userData } = await getSession();
    if (!userData) return;

    const Competencia = Number(competenciaFiltro.split("/").reverse().join(""));
    const { CooperadoID: ID_Cooperado } = userData;
    dispatch(setLoading(true));
    try {
      await procedimentosService.criarProcedimentoCooperado({
        ...form,
        Valor: moneyToNumber(form.Valor),
        Data: formatDataBr(form.Data as string),
        ID_Cooperado,
        ID_Contrato,
        Competencia,
      });
      const { data } = await procedimentosService.buscarProcedimentosCooperado(
        ID_Contrato,
        Competencia,
        userData.CooperadoID
      );

      dispatch(setDadosProcedimentos(data));
      message.success(
        `Procedimento ${form.ID ? "atualizado" : "incluído"} com sucesso`
      );
    } catch (error) {
      parseError(error, "Erro ao tentar conectar");
    } finally {
      dispatch(setLoading(false));
    }
  };
}
function excluirProcedimentosCooperado(ID_Procedimento: string | number) {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    const { userData } = await getSession();
    if (!userData) return;

    dispatch(setLoading(true));
    try {
      await procedimentosService.removerProcedimentoCooperado(ID_Procedimento);

      const {
        procedimentosState: {
          filtros: { competencia, contrato },
        },
      } = getState();
      const competenciaFiltro = Number(
        competencia.split("/").reverse().join("")
      );

      const { data } = await procedimentosService.buscarProcedimentosCooperado(
        contrato,
        competenciaFiltro,
        userData.CooperadoID
      );

      dispatch(setDadosProcedimentos(data));
    } catch (error) {
      parseError(error, "Erro ao tentar conectar");
    } finally {
      dispatch(setLoading(false));
    }
  };
}

function inicializaEstado() {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    const { userData } = await getSession();
    if (!userData) return;

    dispatch(setLoading(true));
    try {
      const {
        procedimentosState: { requisitado },
      } = getState();
      if (!requisitado) {
        dispatch(setRequisitado());
      }

      const { data: respContratos } =
        await procedimentosService.buscarDadosIniciais(userData.CooperadoID);

      if (typeof respContratos === typeof { ListaContrato: [] }) {
        dispatch(setContratos(respContratos.ListaContrato));
      } else {
        throw new Error202("Nenhum Contrato encontrado no período");
      }
    } catch (erro) {
      parseError(erro, "Erro ao tentar conectar");
    } finally {
      dispatch(setLoading(false));
    }
  };
}

const procedimentosActions = {
  inicializaEstado,
  setFiltros,
  setForm,
  limparForm,
  limparFiltros,
  buscarDadosIniciais,
  buscarListaProcedimentos,
  buscarProcedimentosCooperado,
  criarProcedimentosCooperado,
  excluirProcedimentosCooperado,
};

export default procedimentosActions;
